

<template>
  <div
    class="sidebar-logo-container"
    :class="[collapse ? 'collapse': 'notitle']"
  >
    <transition name="sidebarLogoFade">
      <router-link
        v-if="false"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img
          src="favicon.ico"
          class="sidebar-logo"
        >
      </router-link>
      <router-link
        v-else
        key="expand"
        :class="[collapse ? 'sidebar-logo-link' : 'sidebar-logo-link-reduce']"
        to=""
      >
        <!-- <img
          class="sidebar-logo"
          :src="Logo"
        > -->
        <h1 v-if="collapse" class="sidebar-title" :style="{'font-size': language == 'zh-cn' ? '16px' : '12px' }">
          <img class="img-style" src="../../../assets/images/login/CARS.png">
          <span :class="[collapse?'projecttitleblock':'projecttitleblocknone']">{{ $t('robot.projectTtitle') }}</span>
        </h1>
        <h1 v-else><img class="img-style" src="../../../assets/images/login/CARS.png"></h1>
      </router-link>
    </transition>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useStore } from '@/store'
import settings from '@/config/default/setting.config'
import Logo from '@/assets/images/home/logo.png'
export default defineComponent({
  props: {
    collapse: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const store = useStore()
    const title = settings.title
    const language = computed(() => {
      return store.state.app.language
    })
    return {
      title,
      Logo,
      language
    }
  }
})
</script>

<style lang="scss" scoped>
.img-style{
  display: block;
  height: 15px;
  margin: 0 auto;
  margin-bottom: 8px;
}
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}
.projecttitleblock{
  display: block;
  font-size: 15px;
  opacity: 1;
  animation: bottom-top 1s ease-in-out;
  // max-width: 150px;
  // word-wrap: break-word !important;
}

@keyframes bottom-top {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.projecttitleblocknone{
  display: inline;
  transition: 3s;
}
.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  // line-height: 50px;
  background: $menuBg;
  text-align: center;
  overflow: hidden;
  // margin-bottom: 30px;
  // margin-top: 10px;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    & .sidebar-logo {
      display: inline-block;
      height: 30px;
    }

    & .sidebar-title {
      // display: flex;
      // align-items: center;
      margin: 0;
      font-weight: 600;
      // font-size: 16px;
      color: rgba(0,0,0,0.85);
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 12px;
    }
  }
  &.notitle{
    
    & .sidebar-logo-link-reduce {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
    }
       & .sidebar-logo {
      height: 60%;
    }
    .img-style{ 
      height: 12px;
      margin-left: 12px;
    }
  }
}
</style>
